export function truncateNumber(num: number, decimalPlaces: number): number {
  const str = num.toString();
  const index = str.indexOf('.'); // Based on US decimal places
  return index === -1
    ? num
    : parseFloat(str.slice(0, index + decimalPlaces + 1));
}

export const base64Encode = (
  value: string,
  options?: { secure?: boolean },
): string => {
  return btoa(value);
};

export const base64Decode = (
  value: string,
  options?: { secure?: boolean },
): string => {
  return atob(value);
};
